export default "__VITE_ASSET__e18feaf5__"